<template>
  <AuthPageContainer>
    <template #header>
      {{ $t("login.title") }}
    </template>

    <BaseTabSwitcher
      class="w-100"
      v-model="way"
      :tabs="[{
          value: 'email',
          text: $t('login.via_email')
        }, {
          value: 'code',
          text: $t('login.via_code')
        }]"
    />

    <form
      @submit="onFormSubmit"
      class="confirm-employee-form gap-row-lg w-100"
    >
      <div class="gap-row-md w-100">
        <div
          class="form-content gap-row-sm w-100"
          v-if="way == 'email'"
        >
          <div class="w-100 gap-row-1xs">
            <div class="qrw-label-sm bold v1-grey-6-color">
              {{ $t("login.email") }}
            </div>
            <BaseInput
              type="email"
              fullWidth
              :valid="valid"
              name="qrwaiter_login_email"
              required
              placeholder="example@gmail.com"
              v-model="login_data.email"
              data-testid="email_field"
            />
          </div>

          <div class="w-100 gap-row-1xs">
            <div class="qrw-label-sm bold v1-grey-6-color">
              {{ $t("login.password") }}
            </div>
            <BaseInput
              type="password"
              name="qrwaiter_login_password"
              required
              :valid="valid"
              fullWidth
              v-model="login_data.password"
              data-testid="password_field"
            />
          </div>
        </div>

        <div
          class="form-content gap-row-sm w-100"
          v-else
        >
          <div class="qrw-label-sm v1-grey-10-color code-login-text">
            {{ $t('login.code_hint') }}
          </div>
          <FixedCodeInput
            v-model="quick_code"
            :valid="quick_valid"
            @completed="onCodeLogin"
          />
          <div class="qrw-label-sm v1-grey-6-color code-login-text">
            {{ $t('login.code_get') }} <span class="bold">@QRWaiterBusinessBot</span>
          </div>
        </div>

        <div class="gap-row-sm w-100">
          <BaseButton
            variant="tertiary"
            type="button"
            size="md"
            class="w-100"
            color="v1-grey-6"
            v-if="way == 'email'"
            data-testid="forget_button"
            @click="$router.push('/password_recovery')"
          >
            {{ $t("login.forgot") }}
          </BaseButton>
          <BaseDivider
            color="v1-grey-4"
            class="w-100"
          />
          <div class="gap-row-xs w-100">
            <BaseButton
              :disabled="!login_data.password || busy"
              type="submit"
              class="w-100"
              variant="primary"
              bold
              color="green-5"
              size="lg"
              v-if="way == 'email'"
              data-testid="login_button"
            >
              {{ $t("login.login") }}
            </BaseButton>
            <BaseButton
              variant="tertiary"
              color="green-5"
              size="lg"
              data-testid="register_button"
              type="button"
              @click="$router.push('/register')"
            >
              {{ $t("login.register") }}
            </BaseButton>
          </div>
        </div>
      </div>
    </form>
  </AuthPageContainer>
  <!-- </div>

    <img src="../assets/hero-wine.svg" class="auth-panda-icon" />
  </div> -->
</template>

<script>
import AuthPageContainer from '@/components/AuthPageContainer.vue'

import FixedCodeInput from '@/components/FixedCodeInput.vue'

import AuthAPI from '@/api/auth'

export default {
  metaInfo() {
    return {
      title: 'Login - QRWaiter'
    }
  },
  data() {
    return {
      login_data: {
        email: null,
        password: null
      },

      token_2fa: null,
      code_2fa: null,
      phone_mask: null,
      valid: true,
      way: 'email',

      quick_valid: true,

      quick_code: null
    }
  },
  watch: {
    'login_data.password'() {
      this.valid = true
    }
  },
  methods: {
    onCodeLogin() {
      AuthAPI.loginQuick(this.quick_code)
        .then(data => {
          this.$store
            .dispatch('init')
            .then(() => {
              this.$router.push('/')
            })
            .catch(err => {
              this.quick_valid = false
              this.quick_code = null
            })
        })
        .catch(err => {
          this.quick_valid = false
          this.quick_code = null
        })
    },
    onFormSubmit(ev) {
      ev.preventDefault()
      console.log(ev)
      this.$store
        .dispatch('login', this.login_data)
        .then(result => {
          console.log(result)
          if (result && result.two_factor_required) {
            this.token_2fa = result.token
            this.phone_mask = result.phone_mask
            return
          }

          if (this.$store.state.owner && this.$store.state.owner.dashboard_language) {
            this.$i18n.locale = this.$store.state.owner.dashboard_language
          }

          this.$router.push('/')
        })
        .catch(error => {
          console.error(error)
          this.login_data.password = null
          this.$nextTick(() => {
            this.valid = false
          })
        })
    },
    onTwoFactorConfirm() {
      this.$store
        .dispatch('loginTwoFactor', {
          code: this.code_2fa,
          token: this.token_2fa
        })
        .then(ok => {
          this.$router.push('/quickstart')
        })
        .catch(error => {
          this.valid = false
          this.code_2fa = null
        })
    }
  },
  mounted() {
    window.document.body.style.backgroundColor = 'var(--v1-grey-1-color)'

    if (this.$store.state.isLoggedIn) {
      this.$router.push('/')
    }

    this.$store.dispatch('bootIntercom')
  },
  beforeDestroy() {
    window.document.body.style.backgroundColor = 'var(--v1-grey-10-color)'
  },
  components: {
    AuthPageContainer,
    FixedCodeInput
  }
}
</script>

<style scoped>
.confirm-employee-logo-block img {
  width: 32px;
  height: 32px;
  max-height: 32px;
  max-width: 32px;
  min-width: 32px;
  min-height: 32px;
}

.confirm-employee-logo-block {
  justify-content: center;
  width: 100%;
  align-items: center;
  padding-top: 80px;
}

.confirm-employee-form-block {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100%;
  width: 100%;
}

/* .confirm-employee-form {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;

  width: 320px;
  text-align: center;

  margin-top: calc(-80px - 152px);
} */

.auth-panda-icon {
  position: fixed;
  bottom: 0;

  left: 171px;

  width: 150px;
  max-width: 150px;
  height: 150px;
  max-height: 150px;
  min-width: 150px;
}

.code-login-text {
  text-align: center;
}
</style>